// Expiry time (ms) of the access token saved at login ([token, userId] is
// the first item of the login payload). The server verifies the signature;
// here we only read `exp` to end the session in time.
export const getTokenExpiry = (currentUser) => {
  const token = currentUser?.user?.[0]?.[0];
  if (typeof token !== "string" || token.split(".").length !== 3) return null;
  try {
    let part = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    part += "=".repeat((4 - (part.length % 4)) % 4);
    const payload = JSON.parse(atob(part));
    return typeof payload.exp === "number" ? payload.exp * 1000 : null;
  } catch (e) {
    return null;
  }
};

// A session without a readable expiry is treated as expired.
export const isSessionExpired = (currentUser) => {
  const expiry = getTokenExpiry(currentUser);
  return expiry === null || Date.now() >= expiry;
};
